function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Splodge = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactNativeSvg = _interopRequireWildcard(require("react-native-svg/lib/commonjs/ReactNativeSVG.web"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var Splodge = exports.Splodge = (0, _react.memo)(function (props) {
  return (0, _jsxRuntime.jsx)(_reactNativeSvg["default"], Object.assign({
    width: 276,
    height: 167,
    fill: "none",
    "aria-label": "splodge"
  }, props, {
    children: (0, _jsxRuntime.jsx)(_reactNativeSvg.Path, {
      fill: props.fill,
      d: "M234.456 152.065s48.944-16.137 37.231-42.421c0 0-3.91-5.982-20.826-5.201-16.916.782-12.759-17.437-12.759-17.437s2.601-17.956 25.518-30.966c22.916-13.01 7.029-40.602 7.029-40.602S256.854-7.72 206.09 2.69c-50.763 10.41-67.942 29.402-67.942 29.402s-8.849 9.11-43.207 7.291c-34.358-1.818-83.82 49.186-83.82 49.186s-24.991 33.311 0 68.704c24.99 35.393 91.105 0 91.105 0s15.36-12.237 58.056-.263c42.697 11.973 74.174-4.946 74.174-4.946Z"
    })
  }));
});